/* eslint-disable */
export default {
  download: 'Transferir',
  play: 'Reproduzir',
  pause: 'Pausar',
} as const;

// @key: @#@"download"@#@ @source: @#@"Download"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"pause"@#@ @source: @#@"Pause"@#@
